require('./blog');
require('./blurb');
require('./button');
require('./deep-links');
require('./fullwidth-header');
require('./gallery');
require('./person');
require('./search');
require('./slider');
require('./tab');
require('./toggle');
require('./video');


// This prevents Divi from anchor positioning when smooth scrolling
window.et_pb_smooth_scroll = () => {}
	
// this prevents Divi from adding classes to navigation.
window.et_pb_toggle_nav_menu = () => {}